import React from 'react';
import { Gap, Icon, Text } from '@common/components';
import { ColorsType } from 'works/legacy/lib/style-helper';
import { UrgencyLevelType } from '@common/graphql';

export function StatusBadge({
  value,
  type = 'okay',
  info,
}: {
  value: string;
  type?: UrgencyLevelType;
  info?: string;
}) {
  const color = {
    danger: 'coral',
    warning: 'sunDarker',
    okay: 'steel',
  }[type] as ColorsType;

  return (
    <>
      <div className="wk-status-badge">
        <Gap size="xs" align="center">
          <Icon kind="solid" icon="circle" size="sm" color={color} />
          <Text info={info}>{value}</Text>
        </Gap>
      </div>
      <style jsx>{`
        .wk-status-badge {
          display: inline-block;
        }
      `}</style>
    </>
  );
}
